import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import SeatSwapRequestRowHistory from '../../../../../models/seatSwapRequestRowHistory';
import i18n from 'i18next';
import useAppContext from '../../../../../context/useAppContext';
import { ToastContext, Card, HeaderCard, TitleCard, Timeline } from '@weezevent/nacre';
import SwapDetail from './swap-detail/swapDetail';
import LoadingCard from '../../../../../components/loadingCard';

export default function SwapHistory({ attendeeId }) {
    const { t } = useTranslation();

    const locale = i18n.language;
    const [{ organization, event }] = useAppContext();
    const toast = React.useContext(ToastContext);

    const [isFormatting, setIsFormatting] = React.useState(false);

    const [swapHistory, loading] = SeatSwapRequestRowHistory.useApiModel(
        {
            organizationId: organization.pk,
            eventId: event.pk,
            attendeeId: attendeeId,
            onError: () => {
                console.error(t('ticket.attendee.swapHistoryError'));
                toast.error(t('ticket.attendee.swapHistoryError'));
            }
        },
        [organization, event, attendeeId]
    );

    const formattedSwapHistory = React.useMemo(() => {
        setIsFormatting(true);
        if (!swapHistory?.length) {
            setIsFormatting(false);
            return [];
        }

        //Filter swap only confirmed
        let FilteredSwapHistory = swapHistory.filter(swap => swap.request_confirmed !== null);
        if (!FilteredSwapHistory?.length) {
            setIsFormatting(false);
            return [];
        }

        //Create array "history" with 1 event swap === 1 object
        let history = FilteredSwapHistory.reduce((acc, swap) => {
            acc.push({
                title: t('ticket.manager.attendees.detail.swapHistory.swapEventTitle'),
                color: 'ticket',
                content: <SwapDetail data={swap} />,
                date: swap.request_confirmed,
                icon: null
            });
            return acc;
        }, []);

        setIsFormatting(false);
        return history;
    }, [swapHistory]);

    if (!formattedSwapHistory.length) {
        return null;
    }

    return (
        <Card>
            <HeaderCard>
                <TitleCard title={t('ticket.manager.attendees.detail.swapHistory.title')} />
            </HeaderCard>
            {loading || isFormatting ? (
                <Card.Content>
                    <LoadingCard loading />
                </Card.Content>
            ) : (
                <Card.Content>
                    <Timeline locale={locale} timezone={event.timezone} data={formattedSwapHistory} />
                </Card.Content>
            )}
        </Card>
    );
}

SwapHistory.propTypes = {
    attendeeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
